// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__SCizk","selects":"Documents_selects__1xeKd"};